module.exports = __webpack_public_path__ + "media/images/logo-instagram-7273863793afe735496c7bbbd8e840af.svg";